import { render, staticRenderFns } from "./BranchModal.vue?vue&type=template&id=974dd6c4&"
import script from "./BranchModal.vue?vue&type=script&lang=js&"
export * from "./BranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports